import { SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

const EmailRow: FC = () => (
  <div className="border-b p-4 flex flex-col gap-2">
    <div className="flex items-center justify-between gap-2">
      <SkeletonLoader.Text className="h-4 w-40" />
      <SkeletonLoader.Text className="h-3 w-12 shrink-0" />
    </div>
    <SkeletonLoader.Text className="h-4 w-3/4" />
    <SkeletonLoader.Text className="h-3 w-full" />
    <SkeletonLoader.Text className="h-3 w-5/6" />
  </div>
);

const InboxPageSkeleton: FC = () => (
  <div className="h-full md:flex">
    <aside className="w-full md:w-96 shrink-0 border-r flex flex-col min-h-0">
      <div className="p-4 flex items-center justify-between gap-2">
        <SkeletonLoader className="h-7 w-24 rounded" />
        <SkeletonLoader className="h-8 w-8 rounded-lg" />
      </div>
      <div className="px-4 pb-3">
        <SkeletonLoader className="h-9 w-full rounded-lg" />
      </div>
      <div className="flex items-center gap-4 px-4 border-b py-3">
        <SkeletonLoader.Text className="h-4 w-20" />
        <SkeletonLoader.Text className="h-4 w-16" />
        <SkeletonLoader.Text className="h-4 w-20" />
        <SkeletonLoader.Text className="h-4 w-10" />
      </div>
      <div className="overflow-y-auto flex-1">
        {Array.from({ length: 10 }).map((_, i) => (
          <EmailRow key={i} />
        ))}
      </div>
    </aside>

    <div className="hidden md:flex grow flex-col items-center justify-center p-8 gap-3">
      <SkeletonLoader.Circle className="h-16 w-16" />
      <SkeletonLoader.Text className="h-4 w-48" />
      <SkeletonLoader.Text className="h-3 w-64" />
    </div>
  </div>
);

export default InboxPageSkeleton;
